<template>
    <UiCard
        v-if="review && review.id"
        interactive
        class="flex items-center text-xs"
        @click="open"
    >
        <div class="grow-0 px-4 py-2 font-semibold">
            {{ review.id }}
        </div>
        <div class="flex-auto py-2">
            <div>
                {{ review.reviewer.name }}
            </div>
            <div>
                {{ dateHumanReadable(review.completed_at) }}
            </div>
            <div>
                {{ timeHumanReadableFromISO(review.completed_at) }}
            </div>
        </div>
        <div class="grow-0 px-4">
            {{ review.rating }}
        </div>
    </UiCard>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { Review } from '@src/Reviews/Pages/types';
import { dateHumanReadable, timeHumanReadableFromISO } from '@src/Common/Helpers/dates';
import { router } from '@inertiajs/vue3';

const props = defineProps<{
    review: Review;
}>();

const review = toRef(props, 'review');

const open = (): void => {
    router.visit(route('reviews.admin.edit', { id: review.value.id }));
};
</script>
